// ═══════════════════════════════════════════════════════════════
// GeoOps — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '../../components/gab/GabComponents';
import {
  IconLayoutDashboard, IconMap2, IconEye, IconDatabase,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/geoops', icon: IconLayoutDashboard, exact: true },
  { label: 'Map Editor', path: '/geoops/map', icon: IconMap2 },
  { label: 'Zone Overview', path: '/geoops/overview', icon: IconEye },
  { label: 'Data Sources', path: '/geoops/data-sources', icon: IconDatabase },
];

export default function GeoOpsLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('geoops', NAV_ITEMS);

  const isDetail = pathname.match(/\/geoops\/zone\/\d/);
  const isFullscreen = pathname === '/geoops/map' || pathname === '/geoops/overview';

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: isFullscreen ? 0 : '24px', height: isFullscreen ? 'calc(100vh - 92px)' : undefined, overflow: isFullscreen ? 'hidden' : undefined }}>
      {!isDetail && !isFullscreen && (
        <>
        <Breadcrumbs
          items={[
            { label: 'Hub', to: '/' },
            { label: 'GeoOps', to: '/geoops' },
            ...(currentPage && currentPage.path !== '/geoops' ? [{ label: currentPage.label }] : []),
          ]}
        />
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {visibleItems.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
        </>
      )}
      <Outlet />
    </div>
  );
}
